import XRayChart from '../../../components/xRayChart/XRayChart';
import PageWithHeader from '../../../layouts/pageWithHeader/PageWithHeader';

import { useTranslation } from 'react-i18next';
import PageTitleWithTooltip from '../../../components/pageTitleWithTooltip/PageTitleWithTooltip';
import { useAnalysis } from '../../../utils/contexts/AnalysisContext';

import useXRay from './useXRay';
import XRayTooltip from './xRayTooltip/XRayTooltip';

const XRay = () => {
  const {
    xRay,
    progressRange,
    effortRange,
    onClickStudent,
    onClickStudentDetail
  } = useXRay();

  const { t } = useTranslation();
  const { ANALYSIS_SEGMENT } = useAnalysis();

  return (
    <PageWithHeader
      left={
        <PageTitleWithTooltip title={t('x-ray')} testId='x-ray-page-heading' />
      }
      tooltip={<XRayTooltip />}
      pageName={ANALYSIS_SEGMENT.PAGE_NAMES.XRay_Page}
    >
      {xRay && (
        <XRayChart
          data={xRay}
          progressRange={progressRange}
          effortRange={effortRange}
          onClickStudent={onClickStudent}
          onClickStudentDetail={onClickStudentDetail}
        />
      )}
    </PageWithHeader>
  );
};

export default XRay;
